import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function PcaePage() {
  const aide = getAideAgricoleStub('pcae');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
